<ng-container *transloco="let t">
<div class="card d-flex imessage-card">
  <div class="card-header d-flex align-items-center justify-content-center desktop-messages-header" style="min-height: 50px; padding-top: 6px;">
    <h5 class="opacity-80 mb-0">{{ t('portal.messages.title') }}
      @if (messageCount > 0) {
        <span class="imessage-header-badge">{{ messageCount }}</span>
      }
    </h5>
  </div>
  @if (borrowerName) {
    <div class="mobile-messages-header d-none">
      <h6 class="mb-0">{{ borrowerName }}</h6>
      <small class="text-muted">{{ messageCount }} {{ messageCount !== 1 ? t('portal.messages.messagesPlural') : t('portal.messages.messageSingular') }}</small>
    </div>
  }
  <div class="card-body flex-grow-1 p-1" style="height: 350px">
    @if(messageCount == 0 && !isOtherPartyTyping){
    <div class="d-flex flex-column align-items-center justify-content-center h-100 imessage-empty-state">
      <div class="imessage-empty-icon">
        <i class="fa fa-comments"></i>
      </div>
      <span class="imessage-empty-title">{{ t('portal.messages.noMessagesYet') }}</span>
      <span class="imessage-empty-subtitle">{{ t('portal.messages.startConversation') }}</span>
    </div>
    }
    @if(messageCount > 0 || isOtherPartyTyping){
    <div class="h-100 px-2 imessage-thread" style="overflow-x: hidden !important; overflow-y: auto !important" #scrollMe>
      @for (message of messages; track message.messageId) {
      <div class="imessage-row" [class.imessage-row-sent]="userId == message.senderId" [class.imessage-row-received]="userId != message.senderId">
        @if(userId != message.senderId){
        <div class="imessage-bubble imessage-bubble-received">
          <span [innerHTML]="message['mentionableContent']"></span>
        </div>
        }
        @if(userId == message.senderId){
        <div class="imessage-bubble imessage-bubble-sent">
          <span [innerHTML]="message['mentionableContent'] | htmlText"></span>
        </div>
        }
        <div class="imessage-meta" [class.imessage-meta-sent]="userId == message.senderId">
          {{ message.postTime | date : "shortTime" }}
        </div>
      </div>
      }
      @if(isOtherPartyTyping){
      <div class="imessage-row imessage-row-received">
        <div class="imessage-bubble imessage-bubble-received imessage-typing-bubble">
          <div class="imessage-typing-dots">
            <span class="imessage-typing-dot"></span>
            <span class="imessage-typing-dot"></span>
            <span class="imessage-typing-dot"></span>
          </div>
        </div>
      </div>
      }
    </div>
    }
  </div>
  <div class="card-footer imessage-footer">
    <!-- Keyed by currentLang so Angular destroys + re-creates the CKEditor
         instance on language switch, picking up the new placeholder. -->
    @for (lang of [currentLang]; track lang) {
      <message-editor-with-mentions #messageEditor [mentionables]="usersThatCanBeMentioned" (enterHit)="onEnterHit()"
        (messageChanged)="onMessageChanged($event)" [placeholder]="t('portal.messages.typeMessagePlaceholder')">
      </message-editor-with-mentions>
    }
    @if(!isSaving){
    <button class="imessage-send-btn" (click)="postMessage()" [title]="t('portal.messages.sendMessage')">
      <i class="fa fa-paper-plane"></i>
    </button>
    }
    @if(isSaving){
      <div class="imessage-send-spinner">
        <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
      </div>
    }
  </div>
</div>
</ng-container>
